import { create } from "zustand";
import { persist } from "zustand/middleware";
import { setActiveMerchant } from "../api/client";
import type { MerchantInfo } from "../api/types";

interface MerchantState {
  appMerchantId: string | null;
  businessName: string | null;
  connected: boolean;
  setMerchant: (info: MerchantInfo) => void;
  clearMerchant: () => void;
}

export const useMerchantStore = create<MerchantState>()(
  persist(
    (set) => ({
      appMerchantId: null,
      businessName: null,
      connected: false,

      setMerchant: (info: MerchantInfo) => {
        setActiveMerchant(info.app_merchant_id);
        set({
          appMerchantId: info.app_merchant_id,
          businessName: info.business_name,
          connected: info.connected,
        });
      },

      clearMerchant: () => {
        setActiveMerchant(null);
        set({
          appMerchantId: null,
          businessName: null,
          connected: false,
        });
      },
    }),
    {
      name: "scd-merchant",
      // On rehydrate, sync the API client
      onRehydrateStorage: () => (state) => {
        if (state?.appMerchantId) {
          setActiveMerchant(state.appMerchantId);
        }
      },
    },
  ),
);
